import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'hr-announcement-shell',
  templateUrl: './announcement-shell.component.html',
  styleUrls: ['./announcement-shell.component.less'],
  standalone: false,
})
export class AnnouncementShellComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
